/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

const SpriteIconPng = ({
  className,
  src,
  alt,
  width,
  height,
  onClick,
  id,
  tabIndex,
  role
}) => (
  <img
    className={className}
    src={src}
    alt={alt}
    width={width}
    height={height}
    id={id}
    onClick={onClick}
    tabIndex={tabIndex}
    role={role}
  />
);

SpriteIconPng.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  tabIndex: PropTypes.string,
  role: PropTypes.string
};

export default SpriteIconPng;
